module.exports = __webpack_public_path__ + "img/member_reservation_area1.12a99ddf.png";